import React from 'react';
import { aboutData } from '../mock';
import { CheckCircle, Award } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const About = () => {
  return (
    <section id="nosotros" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Company Information */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#0A3A48] mb-4">Nosotros</h2>
            <div className="w-24 h-1 bg-[#5E8B7E] mx-auto"></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-[#0A3A48] mb-6">
                {aboutData.company.name}
              </h3>
              <p className="text-lg text-[#4A4A4A] mb-6 leading-relaxed">
                {aboutData.company.description}
              </p>
              <p className="text-lg text-[#4A4A4A] mb-8 leading-relaxed">
                {aboutData.company.mission}
              </p>

              <div className="space-y-3">
                <h4 className="text-xl font-semibold text-[#0A3A48] mb-4">Nuestro enfoque busca optimizar:</h4>
                {aboutData.company.focus.map((item, index) => (
                  <div key={index} className="flex items-start">
                    <CheckCircle className="text-[#5E8B7E] mr-3 flex-shrink-0 mt-1" size={20} />
                    <span className="text-[#4A4A4A]">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1558464678-2f1570e8d60e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxtb2R1bGFyJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3OTYxODA0OXww&ixlib=rb-4.1.0&q=85"
                alt="EDIFÍSICA"
                className="rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>

        {/* Professional Profile */}
        <Card className="bg-white shadow-xl border-0">
          <CardContent className="p-8 lg:p-12">
            <div className="grid lg:grid-cols-3 gap-8">
              <div className="lg:col-span-1">
                <div className="flex items-center mb-4">
                  <Award className="text-[#5E8B7E] mr-3" size={32} />
                  <h3 className="text-2xl font-bold text-[#0A3A48]">
                    {aboutData.professional.name}
                  </h3>
                </div>
                <p className="text-[#5E8B7E] font-medium mb-6">
                  {aboutData.professional.title}
                </p>
              </div>

              <div className="lg:col-span-2 grid md:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-lg font-semibold text-[#0A3A48] mb-3">Especializaciones</h4>
                  <ul className="space-y-2">
                    {aboutData.professional.specializations.map((item, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-[#5E8B7E] mr-2">•</span>
                        <span className="text-[#4A4A4A] text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div>
                  <h4 className="text-lg font-semibold text-[#0A3A48] mb-3">Áreas de Experticia</h4>
                  <ul className="space-y-2">
                    {aboutData.professional.expertise.map((item, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-[#5E8B7E] mr-2">•</span>
                        <span className="text-[#4A4A4A] text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>

                  <h4 className="text-lg font-semibold text-[#0A3A48] mb-3 mt-6">Certificaciones</h4>
                  <ul className="space-y-2">
                    {aboutData.professional.certifications.map((item, index) => (
                      <li key={index} className="flex items-start">
                        <span className="text-[#5E8B7E] mr-2">•</span>
                        <span className="text-[#4A4A4A] text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default About;